"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * © 2024 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
function ToggleSlider({ fill, ...rest }) {
    return (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: fill, viewBox: "0 0 17 17", ...rest },
        react_1.default.createElement("defs", null,
            react_1.default.createElement("linearGradient", { id: "toggleSlider", x1: "50%", y1: "0%", x2: "50%", y2: "100%" },
                react_1.default.createElement("stop", { offset: "0%", style: { stopColor: "rgb(114, 114, 114)" } }),
                react_1.default.createElement("stop", { offset: "60%", style: { stopColor: "rgb(95,95,95)" } }),
                react_1.default.createElement("stop", { offset: "100%", style: { stopColor: "rgb(88,88,88)" } }))),
        react_1.default.createElement("path", { fill: "url(#toggleSlider)", d: "M8.5,0C3.8,0,0,3.8,0,8.5S3.8,17,8.5,17c4.7,0,8.5-3.8,8.5-8.5S13.2,0,8.5,0z M8.5,11.3C7,11.3,5.8,10,5.8,8.5S7,5.8,8.5,5.8c1.5,0,2.8,1.2,2.8,2.8S10,11.3,8.5,11.3z" }),
        react_1.default.createElement("circle", { cx: "8.5", cy: "8.5", r: "8", fill: "none", stroke: "#231f20", strokeWidth: "1" })));
}
exports.default = ToggleSlider;
//# sourceMappingURL=ToggleSlider.js.map